// Core
import React, { useState, useEffect } from 'react';
import { Card, Typography, Table, Spin } from 'antd';
import { Link, useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
const { Text } = Typography;


// App
import { Main, TableWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import {
  corteCajaListAction
} from '../../../redux/clinica/corte/actionCreator';
import { TipoReporteCorteCaja } from '../../../config/api/enums';

const CorteDiaByCajeroView = ({ setSubmenu }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registros = useSelector(state => state.CorteCajaReducer.data);

  useEffect(() => {
    if (corteCajaListAction) {
      const dia = new Date().getDate();
      dispatch(corteCajaListAction(dia, TipoReporteCorteCaja.PorCajero));
    }
  }, [dispatch]);

  const dataSource = [];

  if (registros.length)
    registros.map((record, key) => {
      const { nombre_empleado, ingresos, forma_pago } = record;
      return dataSource.push({
        key: key + 1,
        nombre_empleado,
        ingresos,
        ingresos_label: (
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(ingresos)
        ),
        forma_pago
      });
    });

  const columns = [
    {
      title: 'Nombre del empleado',
      dataIndex: 'nombre_empleado',
      key: 'nombre_empleado',
    },
    {
      title: 'Forma de pago',
      dataIndex: 'forma_pago',
      key: 'forma_pago',
    },
    {
      title: 'Ingresos',
      dataIndex: 'ingresos_label',
      key: 'ingresos_label',
    },
  ];

  return (
    <>
      {isLoading ? (
        <div className="spin">
          <Spin />
        </div>
      ) : (
        <div>
          <TableWrapper className="table-data-view table-responsive">
            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              locale={{ emptyText: 'Sin registros' }}
              bordered
              summary={pageData => {
                let totalIngresos = 0;
                pageData.forEach(({ ingresos }) => {
                  totalIngresos += parseFloat(ingresos);
                });

                return (
                  <>
                    <Table.Summary.Row style={{background:'#f5f7e1'}}>
                      <Table.Summary.Cell index={0} colSpan={2}><strong>TOTAL</strong></Table.Summary.Cell>                      
                      <Table.Summary.Cell index={2}>
                        <Text>
                          <strong>{new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                          }).format(totalIngresos)}
                          </strong>
                        </Text>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          </TableWrapper>
        </div>
      )}

    </>
  );
};

export default CorteDiaByCajeroView;
